// extracted by mini-css-extract-plugin
export default {"myTeamsTab":"my-teams_myTeamsTab__Ho1vU","searchInput":"my-teams_searchInput__QKuRO"};